<div class="container__desafios" id="menu">
  <div class="menus">
    <div class="menu__desafios" id="menu">
      <button
        class="lovers-button"
        [ngClass]="{ 'lovers-button-unselect': menuItem.id != menuSelecionado }"
        *ngFor="let menuItem of menu"
        (click)="definirSelecionado(menuItem.id)"
      >
        {{ menuItem.descricao }}
      </button>
    </div>
  </div>

  <div class="desafios">
    <div
      class="container__sem__desafios"
      *ngIf="
        desafios.length == 0 && !carregandoDesafios && membro !== undefined
      "
    >
      <img
        class="icone__sem__missoes"
        src="assets/images/icons/sem_missoes.svg"
        alt="Ícone sem missões."
      />
      <h1 class="titulo__sem__missoes">Novas missões estão chegando!</h1>
      <p class="texto__sem__missoes">
        Fique atento, a qualquer momento novas missões estarão disponíveis.
      </p>
    </div>
    <div
      style="position: relative"
      class="desafios__container"
      *ngIf="desafios.length > 0 && !carregandoDesafios && membro !== undefined"
    >
      <div
        class="div__iniciar_todas"
        *ngIf="
          desafios.length > 0 &&
          existeDesafioPendenteAceite &&
          !carregandoDesafios &&
          membro !== undefined &&
          menuSelecionado == 0
        "
      >
        <br />
        <button
          class="btn__iniciar_todas"
          (click)="abrirPopupAceitarTodasMissoes()"
        >
          Iniciar todas as missões
          <img src="assets/images/icons/play.svg" />
        </button>
      </div>
      <div
        class="desafios__loader"
        *ngIf="carregandoDesafios || membro === undefined"
      >
        <ngx-skeleton-loader
          *ngFor="let i of [1, 2, 3, 4, 5]"
          [theme]="{
            'border-radius': '14px',
            width: '256px',
            height: '150px',
            gap: '16px'
          }"
        ></ngx-skeleton-loader>
      </div>
      <div
        class="desafios__loader__mobile"
        *ngIf="carregandoDesafios || membro === undefined"
      >
        <ngx-skeleton-loader
          *ngFor="let i of [1, 2, 3, 4, 5]"
          [theme]="{
            'border-radius': '14px',
            width: '153px',
            height: '202px',
            gap: '16px'
          }"
        ></ngx-skeleton-loader>
      </div>
      <div
        *ngIf="
          desafios.length > 0 && !carregandoDesafios && membro !== undefined
        "
        id="desafios-cards"
        class="desafios__cards"
      >
        <div *ngFor="let desafio of desafiosFiltro">
          <lovers-card-desafio
            #cardComponent
            [desafioId]="desafio.id"
            [titulo]="desafio.titulo"
            [descricao]="desafio.descricao"
            [desafios]="desafio"
            [valorPontosRecompensa]="desafio.valorPontosRecompensa"
            [valorCacausRecompensa]="desafio.valorCacausRecompensa"
            [inicioDesafio]="desafio.inicioDesafio"
            [desafioAceito]="desafio.desafioAceito"
            [fimDesafio]="desafio.fimDesafio"
            [porcentagemDesafio]="desafio.porcentagem"
            [linkVamosLa]="desafio.link"
            [idTipo]="desafio.idTipo"
            [membro]="membro"
            [caminhoImagem]="desafio.caminhoImagem"
            [caminhoImagemMobile]="desafio.caminhoImagemMobile"
            [statusId]="desafio.statusId"
            (onDesafioAceito)="aceitarDesafio(desafio.id)"
            [descricaoDeAceite]="desafio.descricaoDeAceite"
            [ehMissaoDependente]="desafio.ehMissaoDependente"
            [idGrupoMissaoDependente]="desafio.idGrupoMissaoDependente"
            [countMissoesDependente]="desafio.countMissoesDependente"
            [indexGrupoMissaoDependente]="desafio.indexGrupoMissaoDependente"
            [exibeCardsMultiplos]="desafio.exibeAgrupamento"
            [removeMissaoDependenteCompletada]="true"
            [listaMissoesDependente]="desafio.listaMissoesDependente"
            class="card__box"
          >
          </lovers-card-desafio>
        </div>
      </div>
      <button
        class="arrow_left"
        (click)="voltar()"
        [disabled]="!existePaginaAnterior"
        [ngStyle]="{ display: !existePaginaAnterior ? 'none' : 'flex' }"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
        >
          <circle
            cx="24"
            cy="24"
            r="24"
            transform="rotate(-180 24 24)"
            fill="white"
          />
          <path
            d="M26 17.4014L20.0322 23.7007L26 30"
            stroke="#9A2225"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <button
        class="arrow_right"
        (click)="avancar()"
        [disabled]="!existeProximaPagina"
        [ngStyle]="{ display: !existeProximaPagina ? 'none' : 'flex' }"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
        >
          <circle cx="24" cy="24" r="24" fill="white" />
          <path
            d="M22 30.5986L27.9678 24.2993L22 18"
            stroke="#9A2225"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  </div>
</div>

<lovers-popup
  [exibir]="exibirPopupAceitarTodasMissoes"
  (onClose)="exibirPopupAceitarTodasMissoes = false"
  tamanho="pequeno"
>
  <div class="popup__header">
    <p class="header__title">Iniciar todas as missões</p>
  </div>
  <div class="popup__body">
    <div class="lovers-checkbox__container">
      <input
        type="checkbox"
        name="confirmaAceitarTodasMissoes"
        id="confirmaAceitarTodasMissoes"
        [(ngModel)]="confirmaAceitarTodasMissoes"
      />
      <label for="confirmaAceitarTodasMissoes"
        >Estou ciente e aceito os termos de cada missão ativa.</label
      >
    </div>
  </div>
  <div class="popup__footer">
    <div class="footer__content d-flex justify-content-center">
      <button
        class="lovers-button-no-background mr-4"
        [disabled]="aceitandoDesafios"
        (click)="cancelarAceitarTodasMissoes()"
      >
        Cancelar
      </button>
      <button
        class="lovers-button lovers-button-margin-top"
        style="background-color: #ff9999"
        (click)="aceitarTodasMissoes()"
        [disabled]="!confirmaAceitarTodasMissoes || aceitandoDesafios"
      >
        Iniciar todas
      </button>
    </div>
  </div>
</lovers-popup>
